// ===============================================================
// AdminStatCard — Stat card with accent left border
// ===============================================================

export interface AdminStatCardProps {
  label: string;
  value: string | number;
  accent?: string;
  /** Alias for accent — kept for backward compat */
  color?: string;
}

export function AdminStatCard({ label, value, accent, color }: AdminStatCardProps) {
  const accentColor = accent ?? color ?? '#33BCE1';
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 8,
        padding: '16px 20px',
        border: '1px solid #D9D9D9',
        borderLeft: `4px solid ${accentColor}`,
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 26, fontWeight: 800, color: accentColor, lineHeight: 1 }}>
        {value}
      </div>
      <div
        style={{
          fontSize: 10,
          fontWeight: 500,
          color: '#595959',
          marginTop: 5,
          textTransform: 'uppercase' as const,
          letterSpacing: 0.7,
        }}
      >
        {label}
      </div>
    </div>
  );
}
